import React from "react"
import types from "prop-types"
import { questionShape, sectionShape } from "utils/propTypeShapes"
import AnsweredFormOverviewContext from "../AnsweredFormOverviewContext"

const AnsweredFormOverviewContextProvider = ({
  answers,
  children,
  deletedQuestionsNote,
  deletedQuestions,
  flaggedQuestionUuids = [],
  newQuestionUuids,
  sections,
}) => {
  const answer = (questionUuid) => answers[questionUuid]

  const answeredDeletedQuestions = deletedQuestions.filter((deletedQuestion) => answers[deletedQuestion.uuid])

  const isNewQuestion = (questionUuid) => newQuestionUuids.includes(questionUuid)

  const isQuestionFlagged = (questionUuid) => flaggedQuestionUuids.includes(questionUuid)

  // Object exposed to context consumers
  const contextConsumerValue = {
    answer,
    answeredDeletedQuestions,
    answers,
    deletedQuestionsNote,
    isNewQuestion,
    isQuestionFlagged,
    sections,
  }

  return (
    <AnsweredFormOverviewContext.Provider value={contextConsumerValue}>
      {children}
    </AnsweredFormOverviewContext.Provider>
  )
}

AnsweredFormOverviewContextProvider.propTypes = {
  answers: types.object.isRequired,
  children: types.node.isRequired,
  deletedQuestionsNote: types.string.isRequired,
  deletedQuestions: types.arrayOf(questionShape).isRequired,
  flaggedQuestionUuids: types.arrayOf(types.string),
  newQuestionUuids: types.arrayOf(types.string).isRequired,
  sections: types.arrayOf(sectionShape).isRequired,
}

export default AnsweredFormOverviewContextProvider
